export const RASTREAMENTO = () => '/rastreamento';
